import { render } from "./FooterAmount.vue?vue&type=template&id=974c94dc"
import script from "./FooterAmount.vue?vue&type=script&lang=js"
export * from "./FooterAmount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__